/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { FunctionComponent, ComponentType, RefAttributes } from 'react';
import type { WithContextProps } from '@atlaskit/analytics-next/withAnalyticsContext';
import withInjectedProps from '@atlassian/jira-common-util-with-injected-props/src/index.tsx';
import LegacyBreadcrumbAdapter from './component.tsx';
import LegacyApiBridge from './legacy-api-bridge/index.tsx';
import LegacyBreadcrumbConnector from './legacy-breadcrumb-connector/index.tsx';
import LegacyBreadcrumbRenderer, { type Props } from './legacy-breadcrumb-renderer/index.tsx';
import LegacyBreadcrumbState from './legacy-breadcrumb-state/index.tsx';
import type { LegacyBreadcrumbConnectorProps } from './legacy-breadcrumb-connector/types.tsx';
import type { LegacyBreadcrumbStateProviderProps } from './legacy-breadcrumb-state/types.tsx';

// eslint-disable-next-line camelcase
const defaultExport: FunctionComponent<
	Omit<
		Omit<
			{
				LegacyBreadcrumbRenderer: ComponentType<Props>;
				LegacyBreadcrumbState: ComponentType<LegacyBreadcrumbStateProviderProps>;
				LegacyApiBridge: ComponentType<Props>;
				LegacyBreadcrumbConnector: ComponentType<LegacyBreadcrumbConnectorProps>;
			} & WithContextProps &
				RefAttributes<
					({
						LegacyBreadcrumbRenderer,
						LegacyBreadcrumbState,
						LegacyApiBridge,
						LegacyBreadcrumbConnector,
					}: {
						LegacyBreadcrumbRenderer: ComponentType<Props>;
						LegacyBreadcrumbState: ComponentType<LegacyBreadcrumbStateProviderProps>;
						LegacyApiBridge: ComponentType<Props>;
						LegacyBreadcrumbConnector: ComponentType<LegacyBreadcrumbConnectorProps>;
					}) => React.JSX.Element
				>,
			| keyof {
					LegacyBreadcrumbRenderer: ComponentType<Props>;
					LegacyBreadcrumbState: ComponentType<LegacyBreadcrumbStateProviderProps>;
					LegacyApiBridge: ComponentType<Props>;
					LegacyBreadcrumbConnector: ComponentType<LegacyBreadcrumbConnectorProps>;
			  }
			| 'analyticsContext'
			| keyof RefAttributes<
					({
						LegacyBreadcrumbRenderer,
						LegacyBreadcrumbState,
						LegacyApiBridge,
						LegacyBreadcrumbConnector,
					}: {
						LegacyBreadcrumbRenderer: ComponentType<Props>;
						LegacyBreadcrumbState: ComponentType<LegacyBreadcrumbStateProviderProps>;
						LegacyApiBridge: ComponentType<Props>;
						LegacyBreadcrumbConnector: ComponentType<LegacyBreadcrumbConnectorProps>;
					}) => React.JSX.Element
			  >
		> &
			Partial<
				Partial<
					{
						LegacyBreadcrumbRenderer: ComponentType<Props>;
						LegacyBreadcrumbState: ComponentType<LegacyBreadcrumbStateProviderProps>;
						LegacyApiBridge: ComponentType<Props>;
						LegacyBreadcrumbConnector: ComponentType<LegacyBreadcrumbConnectorProps>;
					} & WithContextProps &
						RefAttributes<
							({
								LegacyBreadcrumbRenderer,
								LegacyBreadcrumbState,
								LegacyApiBridge,
								LegacyBreadcrumbConnector,
							}: {
								LegacyBreadcrumbRenderer: ComponentType<Props>;
								LegacyBreadcrumbState: ComponentType<LegacyBreadcrumbStateProviderProps>;
								LegacyApiBridge: ComponentType<Props>;
								LegacyBreadcrumbConnector: ComponentType<LegacyBreadcrumbConnectorProps>;
							}) => React.JSX.Element
						>
				>
			>,
		| keyof {
				LegacyBreadcrumbRenderer: ComponentType<Props>;
				LegacyBreadcrumbState: ComponentType<LegacyBreadcrumbStateProviderProps>;
				LegacyApiBridge: ComponentType<Props>;
				LegacyBreadcrumbConnector: ComponentType<LegacyBreadcrumbConnectorProps>;
		  }
		| 'analyticsContext'
		| keyof RefAttributes<
				({
					LegacyBreadcrumbRenderer,
					LegacyBreadcrumbState,
					LegacyApiBridge,
					LegacyBreadcrumbConnector,
				}: {
					LegacyBreadcrumbRenderer: ComponentType<Props>;
					LegacyBreadcrumbState: ComponentType<LegacyBreadcrumbStateProviderProps>;
					LegacyApiBridge: ComponentType<Props>;
					LegacyBreadcrumbConnector: ComponentType<LegacyBreadcrumbConnectorProps>;
				}) => React.JSX.Element
		  >
	>
> = withInjectedProps(LegacyBreadcrumbAdapter, {
	// @ts-expect-error - Type 'FunctionComponent<Omit<PropsWithDefault, keyof AnalyticsEvents>>' is not assignable to type 'ComponentType<Props> | undefined'.
	LegacyApiBridge,
	LegacyBreadcrumbConnector,
	// @ts-expect-error - TS2322 - Type 'typeof LegacyBreadcrumbState' is not assignable to type 'ComponentType<LegacyBreadcrumbStateProviderProps> | undefined'.
	LegacyBreadcrumbState,
	LegacyBreadcrumbRenderer,
});
export default defaultExport;
